
import { useCookies } from 'react-cookie'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { userStateData } from '../../data/userStateData'
// import './style.scss'

interface DashboardHeaderProps {
	title: string
}

function AdminHeader({title}: DashboardHeaderProps) {

	const [cookies, setCookie, removeCookie] = useCookies(['adminLogin', 'userData'])

	const logoutClickHandler = () => {
		userStateData.logOut()
		removeCookie("adminLogin",{
			path: "/"
		})
		removeCookie("userData",{
			path: "/"
		})
		window.location.replace(PAGE_URLS.APP_ENTRY)
	}

	return (
		<div className='dashboard-header-wrap'>
			<div className='dashboard-header-title'>
				{title}
			</div>
			{userStateData.getUserIconUrl() &&
				<a
					className='dashboard-header-profile-img-wrap'
					href={PAGE_URLS.ADMIN}
				>
					<img 
						className='dashboard-header-profile-img'
						src={userStateData.getUserIconUrl()}
						alt='Profile'
					/>
				</a>
			}
			<div
				className='user-popup-button dashboard-header-profile-logout-button'
				// href={'/'}
				onClick={() => logoutClickHandler()}
			>Logout</div>
		</div>
	)
}

export default AdminHeader